const HOST_API_ROUTE = `${process.env.REACT_APP_CHAT_API_ROUTE}`;
const REACT_APP_KB_API_ROUTE = `${process.env.REACT_APP_KB_API_ROUTE}`;

const CONTACT_API_ROUTE = `${HOST_API_ROUTE}/contact`;
const TOPIC_PAIR_API_ROUTE = `${REACT_APP_KB_API_ROUTE}/topic-pair`;

// contact
export const GET_CONTACTS_FIELD_API_ROUTE = `${CONTACT_API_ROUTE}/get-contacts-field-by-tags`;

// npls
export const GET_ALL_TRIGGERS_BY_TOPIC_EXTERNAL_ID_API_ROUTE = `${TOPIC_PAIR_API_ROUTE}/get-triggers-by-topic-external-id`;